import { isRef, ObjectDirective } from 'vue'

import { isBoolean } from '@vueuse/core'
import type { MaybeRef } from '@vueuse/core'
// import { isElement } from '@vuesax-plus/utils'
// import { useLoading } from '@vuesax-plus/hooks'

type LoadingOptions = {
  loading: MaybeRef<boolean>
}

const loading: ObjectDirective<
  HTMLElement,
  LoadingOptions | LoadingOptions['loading']
> = {
  mounted(el, binding) {
    const value = binding.value

    if (isBoolean(value) || isRef<boolean>(value)) {
      return
    }
  },
}

export default loading
